import moment from "jalali-moment";
import { formats } from "./formats";
import { applyManipulations, createResult } from "./helpers";
import { DateUtilsConvertResult, ToUtcTo } from "./types";

export function toJalali({
  date,
  dateFormat = formats.standard.utcDateTime,
  toFormat = formats.standard.jalaliDateTime,
  manipulate,
  fallback = "",
  convertTime = true,
}: ToUtcTo): DateUtilsConvertResult {
  try {
    if (date === null || date === undefined) {
      throw new Error("date is null or undefined");
    }

    let dateFormatToApply;
    if (typeof date === "string") {
      dateFormatToApply = dateFormat;
    }

    let faDate = convertTime ? moment(date, dateFormatToApply).local() : moment(date, dateFormatToApply);

    if (!faDate.isValid()) {
      throw new Error("converted date is not valid");
    }

    if (manipulate?.length) {
      faDate = applyManipulations(faDate, manipulate);
    }

    return createResult<DateUtilsConvertResult>({ object: faDate.locale("fa"), toFormat });
  } catch (error) {
    return createResult({ fallback });
  }
}

export function toUtc({
  date,
  dateFormat = formats.standard.jalaliDateTime,
  toFormat = formats.standard.utcDateTime,
  manipulate,
  fallback = "",
  convertTime = true,
}: ToUtcTo): DateUtilsConvertResult {
  try {
    if (date === null || date === undefined) {
      throw new Error("date is null or undefined");
    }

    let dateFormatToApply;
    if (typeof date === "string") {
      dateFormatToApply = dateFormat;
    }

    let utcDate = convertTime ? moment(date, dateFormatToApply).utc() : moment(date, dateFormatToApply);

    if (!utcDate.isValid()) {
      throw new Error("converted date is not valid");
    }

    if (manipulate?.length) {
      utcDate = applyManipulations(utcDate, manipulate);
    }

    return createResult<DateUtilsConvertResult>({ object: utcDate.locale("en"), toFormat });
  } catch (error) {
    return createResult({ fallback });
  }
}
